export const translations = {
  az: {
    nav: {
      home: 'Ana Səhifə',
      about: 'Haqqımızda',
      courses: 'Kurslar',
      contact: 'Əlaqə'
    },
    hero: {
      title: 'Gələcəyin Texnologiyalarını',
      titleHighlight: 'Bu Gün Öyrən',
      subtitle: 'İnformatika, robottexnika və proqramlaşdırma sahəsində peşəkar təhsil. Uşaqlarınızın gələcəyinə investisiya edin.',
      cta: 'Kursları Kəşf Et',
      ctaSecondary: 'Bizimlə Əlaqə'
    },
    about: {
      title: 'Haqqımızda',
      subtitle: 'InfoLab Tədris Mərkəzi',
      description: 'InfoLab olaraq, gələcəyin texnologiya sahəsində olacağını nəzərə alaraq, uşaqlarımızı bu sahəyə hazırlayırıq. Müasir tədris metodları və təcrübəli müəllimlər komandamızla hər yaşda şagirdlərə keyfiyyətli təhsil təqdim edirik.',
      features: [
        { title: 'Təcrübəli Müəllimlər', desc: 'Sahəsində peşəkar və təcrübəli komanda' },
        { title: 'Müasir Avadanlıq', desc: 'Ən son texnologiya ilə təchiz olunmuş siniflər' },
        { title: 'Praktiki Dərslər', desc: 'Nəzəri biliklərlə yanaşı praktiki tətbiqlər' },
        { title: 'Kiçik Qruplar', desc: 'Hər şagirdə fərdi yanaşma' }
      ]
    },
    courses: {
      title: 'Kurslarımız',
      subtitle: 'Gələcəyinizi formalaşdıracaq proqramlar',
      detailBtn: 'Ətraflı',
      closeBtn: 'Bağla',
      applyBtn: 'Müraciət et',
      currency: '₼',
      perMonth: '/ay',
      items: [
        {
          id: 1,
          title: 'İnformatika',
          description: 'Məktəblilər üçün informatika dərsləri. Qəbul imtahanına hazırlıq daxil olmaqla bütün mövzular əhatə olunur.',
          features: ['Kompüter əsasları', 'Ofis proqramları', 'Alqoritmlər', 'Qəbul hazırlığı'],
          icon: 'monitor',
          pricing: [{ label: 'Həftədə 2 dəfə / 2 saat', oldPrice: 80, newPrice: 69.99 }],
          fullDescription: 'İnformatika kursu məktəblilərin kompüter sahəsində fundamental biliklərini formalaşdırmaq üçün hazırlanmışdır. Kursda şagirdlər kompüterin iş prinsipləri, əməliyyat sistemləri, ofis proqramları (Word, Excel, PowerPoint), internetdən düzgün istifadə, məlumatların təhlükəsizliyi və alqoritmik düşüncə kimi mövzuları əhatə edirlər. Kurs həmçinin universitet qəbul imtahanlarına hazırlıq proqramını da özündə birləşdirir. Dərslər interaktiv şəkildə keçirilir və hər bir şagirdə fərdi yanaşma təmin edilir.'
        },
        {
          id: 2,
          title: 'Robottexnika',
          description: 'Arduino, avtomatlaşdırma və robot dizaynı. Uşaqlar öz robotlarını yaradır və proqramlaşdırırlar.',
          features: ['Arduino proqramlaşdırma', 'Sensorlar və motorlar', 'Robot dizaynı', 'Avtomatlaşdırma'],
          icon: 'cpu',
          pricing: [{ label: 'Həftədə 2 dəfə / 1.5 saat', oldPrice: 130, newPrice: 109.99 }, { label: 'Həftədə 1 dəfə / 1.5 saat', oldPrice: 80, newPrice: 69.99 }],
          fullDescription: 'Robottexnika kursu uşaqların yaradıcılıq qabiliyyətlərini inkişaf etdirmək və onlara texnologiya dünyasını tanıtmaq məqsədi daşıyır. Kursda Arduino platforması vasitəsilə proqramlaşdırma əsasları, müxtəlif sensorların (işıq, səs, hərəkət) istifadəsi, motorların idarə edilməsi, robot dizaynı və 3D modelləşdirmə öyrədilir. Şagirdlər praktiki layihələr üzərində işləyərək öz robotlarını yaradır və proqramlaşdırırlar. Bu kurs STEM təhsilinin əsas komponentlərindən biridir.'
        },
        {
          id: 3,
          title: 'Proqramlaşdırma',
          description: 'Python, Web Development və layihə əsaslı kodlaşdırma ilə peşəkar proqramçı olma yolu.',
          features: ['Python proqramlaşdırma', 'Web Development', 'Layihə əsaslı kodlaşdırma', 'Alqoritmik düşüncə'],
          icon: 'terminal',
          pricing: [{ label: 'Həftədə 2 dəfə / 1.5 saat', oldPrice: 120, newPrice: 109.99 }],
          fullDescription: 'Web Proqramlaşdırma kursu müasir veb texnologiyalarını sıfırdan öyrətmək üçün nəzərdə tutulmuşdur. Kursda HTML5 ilə veb səhifələrin strukturu, CSS3 ilə dizayn və stilizasiya, JavaScript ilə interaktiv funksionallıq, responsive dizayn prinsipləri və müxtəlif cihazlara uyğunlaşdırma öyrədilir. Şagirdlər kurs müddətində real layihələr üzərində işləyərək öz portfoliolarını yaradırlar. Kurs həm yeni başlayanlar, həm də biliklərini artırmaq istəyənlər üçün uyğundur.'
        },
        {
          id: 4,
          title: 'Dron Texnologiyaları',
          description: 'Dron idarəetməsi, proqramlaşdırılması və avtomatik uçuş missiyalarının hazırlanması.',
          features: ['Dron proqramlaşdırma (Python, C++)', 'Uçuş dinamikası', 'Avtopilot sistemləri', 'Real missiya planlaması'],
          icon: 'plane',
          pricing: [{ label: 'Həftədə 1 dəfə / 1 saat', oldPrice: 110, newPrice: 99.99 }],
          fullDescription: 'Dron Texnologiyaları kursu müasir pilotsuz uçuş aparatlarının (PUA) idarə edilməsi və proqramlaşdırılmasını əhatə edir. Kursda dronların quruluşu və iş prinsipləri, Python və C++ dilləri ilə dron proqramlaşdırılması, sensorların (GPS, akselerometr, giroskop, barometr) istifadəsi, avtopilot sistemləri, avtomatik uçuş missiyalarının planlanması və icra edilməsi öyrədilir. Şagirdlər real dronlar üzərində praktiki təcrübə qazanır, öz uçuş missiyalarını yazır və icra edirlər. Kurs həm hobbi, həm də peşəkar karyera üçün güclü baza yaradır.'
        },
        {
          id: 5,
          title: 'Süni İntellekt və Data Texnologiyaları',
          description: 'Süni intellektin əsasları, Machine Learning və müasir AI alətlərinin praktiki tətbiqi.',
          features: ['Süni intellektin əsasları', 'Machine Learning', 'Data analizi', 'AI alətlərinin tətbiqi'],
          icon: 'brain',
          pricing: [{ label: 'Həftədə 2 dəfə / 1.5 saat', oldPrice: 200, newPrice: 189.99 }],
          fullDescription: 'Süni İntellekt və Data Texnologiyaları kursu müasir dövrün ən tələb olunan sahələrindən birini əhatə edir. Kursda süni intellektin əsas anlayışları və iş prinsipləri, məlumatların toplanması, təmizlənməsi və analizi, Machine Learning alqoritmləri (xətti reqressiya, təsnifat, klasterləşdirmə), Python ilə data emalı (Pandas, NumPy), vizuallaşdırma (Matplotlib), həmçinin ChatGPT, Midjourney, Copilot kimi müasir AI alətlərinin praktiki tətbiqi öyrədilir. Şagirdlər real data setləri üzərində layihələr hazırlayır və süni intellekt modellərini qurmağı öyrənirlər. Kurs gələcəyin ən perspektivli peşələrinə güclü təməl yaradır.'
        },
        {
          id: 6,
          title: 'Təhsil Texnologiyaları və Müəllim Təlimləri',
          description: 'Virtual məktəb, elektron sistemlər və süni intellektin təhsildə tətbiqi üzrə müəllimlər üçün peşəkar təlim.',
          features: ['Virtual məktəb', 'Elektron sistemlərin idarəsi', 'AI ilə dərs tətbiqi', 'Dərs planlaşdırma'],
          icon: 'graduationcap',
          pricing: [{ label: 'Həftədə 1 dəfə / 2 saat', oldPrice: 200, newPrice: 169.99 }],
          fullDescription: 'Təhsil Texnologiyaları və Müəllim Təlimləri kursu müasir müəllimlərin rəqəmsal bacarıqlarını inkişaf etdirmək üçün hazırlanmışdır. Kursda virtual məktəb platformalarının qurulması və idarə edilməsi, elektron jurnal, e-dərslik və LMS (Learning Management System) kimi elektron sistemlərin istifadəsi, süni intellekt alətlərinin (ChatGPT, Gemini, Copilot) dərs prosesində effektiv tətbiqi, AI vasitəsilə dərs planlarının hazırlanması, interaktiv tapşırıqların yaradılması və şagird qiymətləndirmə sistemlərinin avtomatlaşdırılması öyrədilir. Müəllimlər kurs sonunda rəqəmsal sinif mühitini idarə etmək və süni intellektdən pedaqoji alət kimi istifadə etmək bacarığı qazanırlar.'
        }
      ]
    },
    why: {
      title: 'Niyə InfoLab?',
      subtitle: 'Keyfiyyətli təhsil üçün düzgün seçim',
      items: [
        { title: 'Sertifikatlı Proqram', desc: 'Kurs sonunda sertifikat verilir' },
        { title: 'Rahat Qrafik', desc: 'Həftəiçi və həftəsonu qrupları' },
        { title: 'Davamlı Dəstək', desc: 'Kurs müddətində tam dəstək' },
        { title: 'Real Layihələr', desc: 'Praktiki layihələr üzərində iş' }
      ]
    },
    contact: {
      title: 'Əlaqə',
      subtitle: 'Bizimlə əlaqə saxlayın',
      address: 'Ünvan',
      phone: 'Telefon',
      email: 'Email',
      workHours: 'İş saatları',
      workHoursValue: 'Bazar ertəsi - Bazar: 10:00 - 21:00'
    },
    footer: {
      description: 'Gələcəyin texnologiyalarını bu gün öyrənin. InfoLab - texnoloji təhsildə etibarlı partnyorunuz.',
      quickLinks: 'Sürətli Keçidlər',
      followUs: 'Bizi İzləyin',
      rights: 'Bütün hüquqlar qorunur.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      courses: 'Courses',
      contact: 'Contact'
    },
    hero: {
      title: 'Learn Future Technologies',
      titleHighlight: 'Today',
      subtitle: 'Professional education in informatics, robotics and programming. Invest in your children\'s future.',
      cta: 'Explore Courses',
      ctaSecondary: 'Contact Us'
    },
    about: {
      title: 'About Us',
      subtitle: 'InfoLab Education Center',
      description: 'At InfoLab, considering that the future lies in technology, we prepare our children for this field. With modern teaching methods and experienced teachers, we provide quality education to students of all ages.',
      features: [
        { title: 'Experienced Teachers', desc: 'Professional and experienced team' },
        { title: 'Modern Equipment', desc: 'Classrooms equipped with latest technology' },
        { title: 'Practical Lessons', desc: 'Hands-on applications alongside theory' },
        { title: 'Small Groups', desc: 'Individual approach to each student' }
      ]
    },
    courses: {
      title: 'Our Courses',
      subtitle: 'Programs that will shape your future',
      detailBtn: 'Details',
      closeBtn: 'Close',
      applyBtn: 'Apply',
      currency: '₼',
      perMonth: '/mo',
      items: [
        {
          id: 1,
          title: 'Informatics',
          description: 'Informatics lessons for school students. All topics including university entrance exam preparation.',
          features: ['Computer basics', 'Office programs', 'Algorithms', 'Exam preparation'],
          icon: 'monitor',
          pricing: [{ label: '2x per week (1.5 hours)', oldPrice: 80, newPrice: 69.99 }],
          fullDescription: 'The Informatics course is designed to develop fundamental computer knowledge for school students. The course covers computer operation principles, operating systems, office programs (Word, Excel, PowerPoint), proper internet usage, data security, and algorithmic thinking. The course also includes university entrance exam preparation. Classes are conducted interactively with individual attention to each student.'
        },
        {
          id: 2,
          title: 'Robotics',
          description: 'Arduino, automation and robot design. Children create and program their own robots.',
          features: ['Arduino programming', 'Sensors and motors', 'Robot design', 'Automation'],
          icon: 'cpu',
          pricing: [{ label: '2x per week (1.5 hours)', oldPrice: 130, newPrice: 110 }, { label: '1x per week', oldPrice: 80, newPrice: 70 }],
          fullDescription: 'The Robotics course aims to develop children\'s creativity and introduce them to the world of technology. The course teaches programming basics using the Arduino platform, use of various sensors (light, sound, motion), motor control, robot design, and 3D modeling. Students create and program their own robots by working on practical projects. This course is one of the core components of STEM education.'
        },
        {
          id: 3,
          title: 'Web Programming',
          description: 'Learn to create websites and web applications with modern web technologies.',
          features: ['HTML & CSS', 'JavaScript', 'Responsive design', 'Web projects'],
          icon: 'code',
          pricing: [{ label: '', oldPrice: 100, newPrice: 90 }],
          fullDescription: 'The Web Programming course is designed to teach modern web technologies from scratch. The course covers web page structure with HTML5, design and styling with CSS3, interactive functionality with JavaScript, responsive design principles, and adaptation to various devices. Students create their own portfolios by working on real projects during the course. The course is suitable for both beginners and those who want to improve their skills.'
        },
        {
          id: 4,
          title: 'Drone Technologies',
          description: 'Drone operation, programming and preparation of automated flight missions.',
          features: ['Drone programming (Python, C++)', 'Flight dynamics', 'Autopilot systems', 'Real mission planning'],
          icon: 'plane',
          pricing: [{ label: '', oldPrice: 100, newPrice: 80 }],
          fullDescription: 'The Drone Technologies course covers the operation and programming of modern unmanned aerial vehicles (UAVs). The course teaches drone structure and working principles, drone programming with Python and C++, use of sensors (GPS, accelerometer, gyroscope, barometer), autopilot systems, and planning and execution of automated flight missions. Students gain hands-on experience with real drones, write and execute their own flight missions. The course builds a strong foundation for both hobby and professional career paths.'
        },
        {
          id: 5,
          title: 'AI & Data Technologies',
          description: 'Fundamentals of artificial intelligence, Machine Learning and practical application of modern AI tools.',
          features: ['AI fundamentals', 'Machine Learning', 'Data analysis', 'AI tools application'],
          icon: 'brain',
          pricing: [{ label: '', oldPrice: 200, newPrice: 180 }],
          fullDescription: 'The AI & Data Technologies course covers one of the most in-demand fields of the modern era. The course teaches fundamental concepts and principles of artificial intelligence, data collection, cleaning and analysis, Machine Learning algorithms (linear regression, classification, clustering), data processing with Python (Pandas, NumPy), visualization (Matplotlib), as well as practical application of modern AI tools such as ChatGPT, Midjourney, and Copilot. Students work on projects using real datasets and learn to build AI models. The course creates a strong foundation for the most promising careers of the future.'
        },
        {
          id: 6,
          title: 'Programming & Software Development',
          description: 'The path to becoming a professional programmer with Python, Web Development and project-based coding.',
          features: ['Python programming', 'Web Development', 'Project-based coding', 'Algorithmic thinking'],
          icon: 'terminal',
          pricing: [{ label: '', oldPrice: 100, newPrice: 90 }],
          fullDescription: 'The Programming & Software Development course provides students with a professional entry into the modern programming world. The course covers Python programming fundamentals and advanced topics (variables, functions, classes, libraries), Web Development (HTML, CSS, JavaScript, React), database basics, version control with Git, and teamwork principles. Students apply each topic through real projects — calculators, websites, games, APIs and more. The course develops algorithmic thinking and opens doors to a career in any technology field.'
        },
        {
          id: 7,
          title: 'Education Technologies & Teacher Training',
          description: 'Professional training for teachers on virtual schools, electronic systems and AI application in education.',
          features: ['Virtual school', 'Electronic system management', 'AI in classroom', 'Lesson planning'],
          icon: 'graduationcap',
          pricing: [{ label: '', oldPrice: 200, newPrice: 170 }],
          fullDescription: 'The Education Technologies & Teacher Training course is designed to develop the digital skills of modern teachers. The course covers setting up and managing virtual school platforms, using electronic systems such as e-journals, e-textbooks and LMS (Learning Management System), effective application of AI tools (ChatGPT, Gemini, Copilot) in the classroom, preparing lesson plans with AI, creating interactive assignments, and automating student assessment systems. By the end of the course, teachers gain the ability to manage digital classroom environments and use artificial intelligence as a pedagogical tool.'
        }
      ]
    },
    why: {
      title: 'Why InfoLab?',
      subtitle: 'The right choice for quality education',
      items: [
        { title: 'Certified Program', desc: 'Certificate upon course completion' },
        { title: 'Flexible Schedule', desc: 'Weekday and weekend groups' },
        { title: 'Continuous Support', desc: 'Full support during the course' },
        { title: 'Real Projects', desc: 'Work on practical projects' }
      ]
    },
    contact: {
      title: 'Contact',
      subtitle: 'Get in touch with us',
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
      workHours: 'Working Hours',
      workHoursValue: 'Monday - Saturday: 09:00 - 20:00'
    },
    footer: {
      description: 'Learn future technologies today. InfoLab - your trusted partner in technology education.',
      quickLinks: 'Quick Links',
      followUs: 'Follow Us',
      rights: 'All rights reserved.'
    }
  }
};

export const contactInfo = {
  address: '33A Zaur Şərifov, Bakı',
  phone: '+994 55 531 35 32',
  email: 'office@infolab.az',
  social: {
    instagram: '#',
    facebook: '#',
    whatsapp: '#',
    telegram: '#'
  }
};
